import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
} from '@mui/material';
import {
    CHART_SAMPLING_OPTIONS,
    CHART_SAMPLING_TYPE_OPTIONS,
    ChartSamplingFilter,
    ChartSamplingTypeFilter,
} from '../../../../constants/data.constants';
import { FlexBoxFullW } from '../../../layout/layout.styles';

const ChartFilters = ({
    selectedFilter,
    selectedType,
    onFilterChange,
    onFilterTypeChange,
}: {
    selectedFilter: ChartSamplingFilter;
    selectedType: ChartSamplingTypeFilter;
    onFilterChange: (filter: ChartSamplingFilter) => void;
    onFilterTypeChange: (filter: ChartSamplingTypeFilter) => void;
}) => {
    const handleFilterChange = (event: SelectChangeEvent) => {
        const key = event.target.value as keyof typeof CHART_SAMPLING_OPTIONS;
        const filter = CHART_SAMPLING_OPTIONS.find((f) => f.key === key);
        if (filter) onFilterChange(filter);
    };

    const handleFilterTypeChange = (event: SelectChangeEvent) => {
        const key = event.target
            .value as keyof typeof CHART_SAMPLING_TYPE_OPTIONS;
        const filter = CHART_SAMPLING_TYPE_OPTIONS.find((f) => f.key === key);
        if (filter) onFilterTypeChange(filter);
    };

    return (
        <FlexBoxFullW py={1}>
            <Box width={1 / 2}>
                <FormControl fullWidth>
                    <InputLabel id="chart-sampling-filter-label">
                        Campionamento
                    </InputLabel>
                    <Select
                        labelId="chart-sampling-filter-label"
                        id="chart-sampling-filter"
                        value={selectedFilter.key}
                        label="Campionamento"
                        onChange={handleFilterChange}
                    >
                        {CHART_SAMPLING_OPTIONS.map((filter) => (
                            <MenuItem key={filter.key} value={filter.key}>
                                {filter.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
            {selectedFilter.zoom !== 'raw' && (
                <Box width={1 / 2} pl={2}>
                    <FormControl fullWidth>
                        <InputLabel id="chart-type-filter-label">
                            Tipo
                        </InputLabel>
                        <Select
                            labelId="chart-type-filter-label"
                            id="chart-type-filter"
                            value={selectedType.key}
                            label="Tipo"
                            onChange={handleFilterTypeChange}
                        >
                            {CHART_SAMPLING_TYPE_OPTIONS.map((filter) => (
                                <MenuItem key={filter.key} value={filter.key}>
                                    {filter.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            )}
        </FlexBoxFullW>
    );
};

export default ChartFilters;
